// removed by extract-text-webpack-plugin
module.exports = {"propertiesContainer":"_2wsge6Wca1a-ZTr07KEnsI","properties":"_2C5p4kcQv-UK5CzaMT-2ca","showMoreButton":"_3flrWDfN54OI9OVvk2BFK6"};


//////////////////
// WEBPACK FOOTER
// ./src/components/RealtorUser/CompanyProperties/CompanyProperties.scss
// module id = 1760
// module chunks = 0